import { render } from "./EditEvents.vue?vue&type=template&id=cca9025a"
import script from "./EditEvents.vue?vue&type=script&lang=js"
export * from "./EditEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__